function _extractControlRecord(data) {
  const controlRecords = data.oms_control_records || [data];
  const saleTransaction = { ...data };
  delete saleTransaction.oms_control_records;
  return controlRecords.map((cr) => ({
    ...saleTransaction,
    sale_transaction: saleTransaction,
    ...cr,
  }));
}

function extractControlRecord(data) {
  if (!Array.isArray(data)) {
    return _extractControlRecord(data);
  }

  return data.reduce(
    (arr, line) => arr.concat(_extractControlRecord(line)),
    [],
  );
}

function hasUnholdStatus(data) {
  const controlRecords = extractControlRecord(data);
  const hasOnhold = controlRecords.some(({ on_hold }) => on_hold);
  return hasOnhold;
}

function hasHoldStatus(data) {
  const controlRecords = extractControlRecord(data);
  const hasOnhold = controlRecords.some(({ on_hold }) => !on_hold);
  return hasOnhold;
}

function hasPendingStatus(data) {
  const controlRecords = extractControlRecord(data);
  const hasPending = controlRecords.some(({ pick, pack }) => !pick && !pack);
  return hasPending;
}

function hasPickedStatus(data) {
  const controlRecords = extractControlRecord(data);
  const hasPick = controlRecords.some(({ pick }) => pick);
  return hasPick;
}

function allPickedStatus(data) {
  const controlRecords = extractControlRecord(data);
  const hasPick = controlRecords.every(({ pick }) => pick);
  return hasPick;
}

function hasPackedStatus(data) {
  const controlRecords = extractControlRecord(data);
  const hasPack = controlRecords.some(({ pack }) => pack);
  return hasPack;
}

function beautifyFreightStatus(freight_status) {
  if (!freight_status) return freight_status;
  return freight_status.toUpperCase().replace(/_/g, ' ');
}

export {
  beautifyFreightStatus,
  extractControlRecord,
  hasHoldStatus,
  hasPackedStatus,
  hasPendingStatus,
  hasPickedStatus,
  hasUnholdStatus,
  allPickedStatus,
};
